export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  description: string;
  longDescription: string;
  director: string;
  actors: string[];
  region: string;
  language: string;
  duration: string;
  releaseDate: string;
  posterUrl: string;
  backdropUrl: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
  viewCount: number;
}

export const movieCategories = [
  { name: "动作片", slug: "action", icon: "ri-sword-line" },
  { name: "喜剧片", slug: "comedy", icon: "ri-emotion-happy-line" },
  { name: "爱情片", slug: "romance", icon: "ri-heart-line" },
  { name: "科幻片", slug: "scifi", icon: "ri-rocket-line" },
  { name: "恐怖片", slug: "horror", icon: "ri-ghost-line" },
  { name: "剧情片", slug: "drama", icon: "ri-film-line" },
  { name: "悬疑片", slug: "mystery", icon: "ri-search-eye-line" },
  { name: "动画片", slug: "animation", icon: "ri-emotion-laugh-line" },
  { name: "纪录片", slug: "documentary", icon: "ri-camera-lens-line" },
  { name: "战争片", slug: "war", icon: "ri-shield-flash-line" },
];

export const movies: Movie[] = [
  {
    id: "movie-001",
    title: "流浪地球3",
    titleEn: "The Wandering Earth 3",
    year: 2026,
    category: "科幻片",
    categorySlug: "scifi",
    rating: 8.6,
    description: "太阳急速老化，持续膨胀，地球面临被吞没的危机。人类再次团结一致，带着地球踏上更加惊心动魄的星际流浪之旅。",
    longDescription: "在《流浪地球3》中，太阳急速老化并持续膨胀，地球面临被吞没的巨大危机。为了应对这一末日级别的挑战，人类再次团结起来，启动了更加宏伟的地球流浪计划。影片在前两部的基础上进一步拓展了宏大的宇宙世界观，带来前所未有的视觉奇观。主人公刘启带领着新一代的救援队员，在太空中展开了一场惊心动魄的星际救援行动。面对未知的宇宙威胁和人类内部的矛盾，他们必须做出艰难的抉择。影片不仅展现了中国科幻电影的视觉想象力，更深入探讨了人类在面对灭顶之灾时的勇气、牺牲与希望。特效场面宏大壮阔，情感叙事细腻动人，是一部兼具商业性与艺术性的科幻巨制。",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健", "沙溢", "宁理"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "150分钟",
    releaseDate: "2026-02-10",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20helmet%20reflecting%20burning%20sun%20against%20dark%20space%20background%2C%20dramatic%20lighting%2C%20epic%20cinematic%20composition%2C%20orange%20and%20gold%20accents%2C%20clean%20minimal%20design%2C%20movie%20poster%20style&width=600&height=900&seq=movie-poster-001&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20giant%20planet%20engine%20thrusters%20glowing%20orange%20against%20dark%20cosmic%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20film%20grain%20texture%2C%20warm%20amber%20and%20deep%20space%20contrast&width=1600&height=900&seq=movie-backdrop-001&orientation=landscape",
    isHot: true,
    isNew: true,
    tags: ["科幻巨制", "视觉盛宴", "国产科幻"],
    viewCount: 1528000,
  },
  {
    id: "movie-002",
    title: "红海行动2：蛟龙出击",
    titleEn: "Operation Red Sea 2",
    year: 2026,
    category: "动作片",
    categorySlug: "action",
    rating: 8.4,
    description: "蛟龙突击队再次集结，深入战火纷飞的异国他乡，执行一项危险万分的撤侨任务，热血与牺牲铸就铁血军魂。",
    longDescription: "《红海行动2：蛟龙出击》延续了前作的硬核军事动作风格，讲述了蛟龙突击队在海外执行撤侨任务时遭遇的惊险故事。影片根据真实事件改编，展现了中国军人在危难时刻挺身而出的英勇无畏。在战火纷飞的异国他乡，蛟龙突击队八人小组深入敌后，面对数倍于己的敌人和复杂多变的战场环境，他们以过硬的军事素养和钢铁般的意志，完成了一项又一项看似不可能的任务。影片动作场面火爆震撼，战术细节真实考究，情感表达真挚动人。从沙漠追击到海上激战，从城市巷战到山地狙击，每一场战斗都让人肾上腺素飙升。这不仅是一部军事动作片，更是一曲献给和平守护者的英雄赞歌。",
    director: "林超贤",
    actors: ["张译", "黄景瑜", "海清", "杜江", "蒋璐霞"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "138分钟",
    releaseDate: "2026-01-25",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20military%20action%20movie%20poster%20with%20special%20forces%20soldiers%20in%20tactical%20gear%20against%20desert%20battlefield%20backdrop%2C%20explosive%20action%2C%20warm%20desert%20tones%2C%20cinematic%20composition%2C%20dramatic%20lighting&width=600&height=900&seq=movie-poster-002&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Military%20action%20scene%20with%20special%20forces%20team%20advancing%20through%20dust%20and%20smoke%20in%20desert%20environment%2C%20cinematic%20warfare%20photography%2C%20warm%20sand%20and%20smoke%20tones%2C%20dramatic%20lighting&width=1600&height=900&seq=movie-backdrop-002&orientation=landscape",
    isHot: true,
    isNew: true,
    tags: ["军事动作", "真实改编", "热血燃爆"],
    viewCount: 1285000,
  },
  {
    id: "movie-003",
    title: "长安三万里2",
    titleEn: "Chang'an 2",
    year: 2026,
    category: "动画片",
    categorySlug: "animation",
    rating: 8.8,
    description: "继续跟随诗仙李白的脚步，梦回大唐盛世，在诗与画中感受中华文化的博大精深与浪漫豪情。",
    longDescription: "《长安三万里2》延续了第一部的史诗动画风格，继续以诗仙李白和诗圣杜甫的视角，带领观众穿越回那个群星璀璨的盛唐时代。影片以更加宏大的叙事格局，展现了大唐从极盛到动荡的历史画卷。精美的动画画面将长安城的繁华盛景、边塞的雄浑壮阔、江南的婉约秀丽一一呈现。影片不仅是一场视觉的饕餮盛宴，更是一次中华传统文化的深度浸润。从李白的豪放不羁到杜甫的家国情怀，从王维的山水意境到王昌龄的边塞豪情，每一位诗人都在银幕上栩栩如生。影片在传承经典的同时，也融入了现代动画技术的创新表达，让千年诗句在光影中焕发出新的生命力。",
    director: "谢君伟",
    actors: ["杨天翔", "凌振赫", "吴俊全"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "168分钟",
    releaseDate: "2026-07-15",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20featuring%20ancient%20Tang%20dynasty%20poet%20in%20traditional%20robes%20against%20golden%20palace%20and%20mountain%20landscape%2C%20ink%20wash%20painting%20style%2C%20elegant%20warm%20gold%20and%20vermilion%20tones&width=600&height=900&seq=movie-poster-003&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20with%20golden%20palace%20rooftops%20at%20sunset%2C%20traditional%20Chinese%20painting%20aesthetic%2C%20warm%20golden%20and%20crimson%20tones%2C%20atmospheric%20cinematic%20composition&width=1600&height=900&seq=movie-backdrop-003&orientation=landscape",
    isHot: true,
    isNew: false,
    tags: ["国产动画", "历史文化", "视觉盛宴"],
    viewCount: 2100000,
  },
  {
    id: "movie-004",
    title: "满江红2",
    titleEn: "Full River Red 2",
    year: 2026,
    category: "悬疑片",
    categorySlug: "mystery",
    rating: 8.2,
    description: "南宋绍兴年间，一场离奇的密室命案牵出一段尘封已久的惊天秘密，层层反转，不到最后一刻猜不到结局。",
    longDescription: "《满江红2》延续了第一部的悬疑喜剧风格，再次将观众带回南宋绍兴年间那个波谲云诡的时代。影片以一个全新的悬疑案件为切入点，在一座封闭的古宅之中，一场离奇的命案牵出了各方势力的角逐。随着调查的深入，一个关乎国家命运的惊天秘密逐渐浮出水面。张艺谋导演以其独特的视觉美学，将古建筑的几何美感与悬疑氛围完美融合。影片在紧张的推理过程中穿插了恰到好处的黑色幽默，节奏张弛有度。每一个角色都暗藏秘密，每一次反转都出人意料。当真相最终揭晓的那一刻，观众才恍然大悟：原来所有的线索早已埋藏在开篇的每一个细节之中。",
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译", "雷佳音", "岳云鹏"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "159分钟",
    releaseDate: "2026-05-01",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20movie%20poster%20with%20ancient%20courtyard%20architecture%20and%20shadowy%20figures%20in%20traditional%20Song%20dynasty%20costumes%2C%20dark%20crimson%20and%20gold%20accents%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style&width=600&height=900&seq=movie-poster-004&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20compound%20with%20narrow%20corridors%20and%20red%20lanterns%20at%20night%2C%20mysterious%20atmosphere%2C%20warm%20lantern%20glow%20against%20deep%20shadows%2C%20cinematic%20noir%20lighting&width=1600&height=900&seq=movie-backdrop-004&orientation=landscape",
    isHot: false,
    isNew: true,
    tags: ["悬疑反转", "张艺谋", "古装大片"],
    viewCount: 980000,
  },
  {
    id: "movie-005",
    title: "热辣滚烫2",
    titleEn: "YOLO 2",
    year: 2026,
    category: "喜剧片",
    categorySlug: "comedy",
    rating: 7.9,
    description: "乐莹在拳击生涯获得成功后，开启了全新的人生旅程，这一次她在都市丛林中找到了属于自己的快乐密码。",
    longDescription: "《热辣滚烫2》讲述了乐莹在拳击赛场取得成功之后的故事。从一个自卑的胖女孩到自信的拳击手，乐莹的蜕变激励了无数人。在这一部中，乐莹面临着全新的挑战：如何在繁华都市中保持自我，如何在名利场中不忘初心。她开了一家属于自己的拳击健身房，帮助那些和她曾经一样迷茫的人找到人生的方向。影片延续了第一部的温暖治愈风格，在幽默诙谐中传递着积极向上的生活态度。贾玲导演以其独特的女性视角，细腻地刻画了当代都市人的生活困境与情感需求。影片笑中带泪，既有让人捧腹的喜剧桥段，也有让人深思的生活哲理。",
    director: "贾玲",
    actors: ["贾玲", "雷佳音", "张小斐", "杨紫"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "129分钟",
    releaseDate: "2026-02-10",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20a%20confident%20woman%20in%20boxing%20gloves%20smiling%20against%20vibrant%20city%20backdrop%2C%20warm%20pink%20and%20coral%20tones%2C%20uplifting%20and%20energetic%20composition%2C%20clean%20minimal%20design&width=600&height=900&seq=movie-poster-005&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Vibrant%20modern%20city%20streets%20at%20golden%20hour%20with%20warm%20sunlight%20streaming%20through%20buildings%2C%20energetic%20and%20uplifting%20atmosphere%2C%20cinematic%20urban%20photography%2C%20warm%20peach%20and%20gold%20tones&width=1600&height=900&seq=movie-backdrop-005&orientation=landscape",
    isHot: false,
    isNew: false,
    tags: ["喜剧励志", "女性题材", "温暖治愈"],
    viewCount: 860000,
  },
  {
    id: "movie-006",
    title: "封神第二部",
    titleEn: "Creation of the Gods II",
    year: 2026,
    category: "动作片",
    categorySlug: "action",
    rating: 8.3,
    description: "殷商大军兵临西岐，姜子牙率领昆仑仙人助阵，一场决定天下归属的惊天大战即将震撼上演。",
    longDescription: "《封神第二部》紧接第一部的剧情，殷商大军在闻仲太师的统领下兵临西岐城下。姜子牙率领昆仑山众仙人下山相助，一场人、仙、妖三界混战的史诗对决就此展开。影片在视觉效果上全面升级，从宏大的战争场面到精细的法术特效，从人物造型到场景设计，都展现了中国电影工业的最高水准。乌尔善导演以十年磨一剑的匠心精神，将中国古典神话的瑰丽想象转化为震撼人心的视觉奇观。影片在激烈的神魔大战之外，也深入刻画了姬发、殷郊等年轻角色的成长弧光，以及纣王与妲己之间复杂的情感纠葛。这不仅仅是一部神话大片，更是对权力、欲望与人性的深刻探讨。",
    director: "乌尔善",
    actors: ["费翔", "李雪健", "黄渤", "于适", "陈牧驰"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "148分钟",
    releaseDate: "2026-07-20",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20beasts%20in%20battle%2C%20bronze%20and%20gold%20color%20palette%2C%20grand%20epic%20composition%2C%20traditional%20Chinese%20aesthetic%2C%20dramatic%20lighting&width=600&height=900&seq=movie-poster-006&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20battlefield%20with%20thousands%20of%20warriors%20and%20mythical%20creatures%20clashing%20under%20dramatic%20stormy%20sky%2C%20bronze%20and%20gold%20armor%20reflecting%20lightning%2C%20cinematic%20grandeur&width=1600&height=900&seq=movie-backdrop-006&orientation=landscape",
    isHot: true,
    isNew: true,
    tags: ["神话史诗", "视觉盛宴", "国产大片"],
    viewCount: 1890000,
  },
  {
    id: "movie-007",
    title: "飞驰人生3",
    titleEn: "Pegasus 3",
    year: 2026,
    category: "喜剧片",
    categorySlug: "comedy",
    rating: 7.8,
    description: "张驰再次踏上赛道，这一次他不再是独自战斗，一群怀揣梦想的年轻人加入了他的车队，一起冲向新的终点。",
    longDescription: "《飞驰人生3》讲述了曾经的拉力赛冠军张驰在重返赛场后，组建了一支全新的车队。这一次，他不再是一个人在战斗，一群同样热爱赛车的年轻人加入了他的团队。从改装车间到国际赛道，从国内拉力赛到世界锦标赛，张驰带领着他的团队一路披荆斩棘。影片在保持前两部喜剧风格的同时，更加深入地刻画了赛车手这个群体的生存状态和精神追求。韩寒导演以其对赛车运动的热爱和理解，将速度与激情的魅力展现得淋漓尽致。引擎的轰鸣声、轮胎与地面的摩擦声、观众席上山呼海啸的欢呼声，每一个细节都让观众仿佛置身赛场。",
    director: "韩寒",
    actors: ["沈腾", "尹正", "黄景瑜", "范丞丞", "张本煜"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "122分钟",
    releaseDate: "2026-02-10",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20racing%20car%20speeding%20on%20track%20against%20sunset%20sky%2C%20motion%20blur%20effect%2C%20warm%20orange%20and%20teal%20contrast%2C%20dynamic%20action%20composition%2C%20cinematic%20style&width=600&height=900&seq=movie-poster-007&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Racing%20cars%20on%20a%20winding%20mountain%20track%20at%20golden%20hour%2C%20dust%20trails%20and%20motion%20blur%2C%20dramatic%20sunset%20lighting%2C%20cinematic%20sports%20photography%2C%20warm%20golden%20tones&width=1600&height=900&seq=movie-backdrop-007&orientation=landscape",
    isHot: false,
    isNew: true,
    tags: ["赛车喜剧", "韩寒导演", "春节档"],
    viewCount: 720000,
  },
  {
    id: "movie-008",
    title: "深海2",
    titleEn: "Deep Sea 2",
    year: 2026,
    category: "动画片",
    categorySlug: "animation",
    rating: 8.5,
    description: "少女参宿再次坠入深海梦境，这一次她将以更加勇敢的姿态，与新的伙伴一起探索那片神秘而瑰丽的海底世界。",
    longDescription: "《深海2》延续了第一部的独特视觉美学，以更加成熟的技术手段打造了一个前所未有的深海奇幻世界。少女参宿在新的一年再次坠入那个充满魔法与神秘的深海梦境。这一次，她不再是一个迷茫无助的小女孩，而是带着第一段冒险中获得的勇气和智慧，与新的伙伴一起探索这片瑰丽而危险的深海世界。影片采用了更加先进的粒子水墨技术，将中国传统水墨画的意境与现代CG技术完美融合。每一帧画面都是一幅精美的艺术品，从绚烂的珊瑚森林到幽暗的深海峡谷，从活泼的海洋生物到神秘的远古遗迹，视觉体验令人叹为观止。",
    director: "田晓鹏",
    actors: ["苏鑫", "王亭文", "滕奎兴"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "112分钟",
    releaseDate: "2026-08-10",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20young%20girl%20floating%20in%20deep%20sea%20surrounded%20by%20glowing%20jellyfish%20and%20colorful%20coral%2C%20dreamy%20underwater%20scene%2C%20particle%20ink%20style%2C%20vibrant%20bioluminescent%20tones&width=600&height=900&seq=movie-poster-008&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Magical%20deep%20sea%20underwater%20scene%20with%20bioluminescent%20creatures%20and%20swirling%20ink-like%20particles%2C%20dreamy%20fantasy%20atmosphere%2C%20vibrant%20coral%20and%20deep%20blue%20contrast%2C%20cinematic%20underwater%20photography&width=1600&height=900&seq=movie-backdrop-008&orientation=landscape",
    isHot: false,
    isNew: false,
    tags: ["国产动画", "视觉奇观", "深海奇幻"],
    viewCount: 1350000,
  },
  {
    id: "movie-009",
    title: "无名2",
    titleEn: "Hidden Blade 2",
    year: 2026,
    category: "剧情片",
    categorySlug: "drama",
    rating: 8.1,
    description: "抗战时期的上海，无名英雄们在暗流涌动的谍战世界中，用生命和智慧书写了一段惊心动魄的隐秘传奇。",
    longDescription: "《无名2》继续讲述抗战时期上海隐蔽战线的故事。程耳导演以其独特的非线性叙事手法，将谍战世界中错综复杂的人物关系和惊心动魄的情节发展编织成一幅精密的叙事网络。影片以更加宏大的格局展现了那个特殊年代里，一群无名英雄如何在敌人的心脏地带开展秘密工作。梁朝伟、王一博等演员的精湛演技让每一个角色都立体丰满。影片在紧张的谍战氛围中融入了对人性的深刻洞察，在黑白灰的色调中偶尔闪现的一抹红色，既是视觉上的点睛之笔，也暗示着那个年代特有的残酷与浪漫。",
    director: "程耳",
    actors: ["梁朝伟", "王一博", "周迅", "王传君"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "132分钟",
    releaseDate: "2026-01-22",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20spy%20thriller%20movie%20poster%20with%20man%20in%20vintage%20suit%20and%20hat%20in%20rainy%201940s%20Shanghai%20alley%2C%20noir%20lighting%2C%20film%20noir%20aesthetic%2C%20dark%20moody%20atmosphere%2C%20cigarette%20smoke%20texture&width=600&height=900&seq=movie-poster-009&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=1940s%20Shanghai%20street%20at%20night%20with%20rain-soaked%20cobblestones%20and%20neon%20signs%20reflecting%2C%20noir%20cinematography%2C%20dark%20moody%20atmosphere%2C%20vintage%20Chinese%20cityscape&width=1600&height=900&seq=movie-backdrop-009&orientation=landscape",
    isHot: false,
    isNew: false,
    tags: ["谍战悬疑", "演技派", "文艺大片"],
    viewCount: 650000,
  },
  {
    id: "movie-010",
    title: "独行月球2",
    titleEn: "Moon Man 2",
    year: 2026,
    category: "科幻片",
    categorySlug: "scifi",
    rating: 7.7,
    description: "独孤月在月球基地的冒险仍在继续，一只意外出现的月球生物让他的独居生活变得热闹而又充满未知的危险。",
    longDescription: "《独行月球2》延续了第一部的科幻喜剧风格。独孤月以为自己在月球上的独居生活已经够疯狂了，直到他在月球基地深处发现了一个神秘的生物。这个来自月球内部的奇特生命体不仅打破了他平静的日常，还带来了一系列啼笑皆非的麻烦。从追逐战到合作求生，独孤月和这个月球生物之间建立了一段奇妙的友谊。影片在轻松幽默的表象下，探讨了孤独、陪伴以及人类与未知生命共处等深刻主题。沈腾的喜剧表演依旧出色，而月球生物的设计充满了想象力和萌趣感，给观众带来了全新的观影体验。",
    director: "张吃鱼",
    actors: ["沈腾", "马丽", "黄才伦"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "118分钟",
    releaseDate: "2026-07-29",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20comedy%20movie%20poster%20with%20astronaut%20and%20cute%20alien%20creature%20on%20lunar%20surface%2C%20Earth%20visible%20in%20background%2C%20warm%20humorous%20tone%2C%20contrast%20of%20gray%20moon%20and%20blue%20Earth&width=600&height=900&seq=movie-poster-010&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Lunar%20surface%20landscape%20with%20isolated%20moon%20base%20and%20Earth%20rising%20over%20cratered%20horizon%2C%20starry%20space%20background%2C%20cinematic%20sci-fi%20photography%2C%20cool%20silver%20and%20deep%20space%20contrast&width=1600&height=900&seq=movie-backdrop-010&orientation=landscape",
    isHot: false,
    isNew: true,
    tags: ["科幻喜剧", "沈腾马丽", "暑期档"],
    viewCount: 560000,
  },
  {
    id: "movie-011",
    title: "人生大事2",
    titleEn: "Lighting Up the Stars 2",
    year: 2026,
    category: "剧情片",
    categorySlug: "drama",
    rating: 8.7,
    description: "莫三妹的殡葬店迎来了新的故事，生与死的交织中，平凡人的生活继续上演着温暖与感动的人间烟火。",
    longDescription: "《人生大事2》延续了第一部的现实主义温情路线。莫三妹的殡葬店依旧开在那条熟悉的街道上，而新的故事也在不断上演。这一次，影片通过几个不同家庭的殡葬故事，展现了当代中国人面对生死时的情感世界。从白发人送黑发人的悲痛欲绝，到寿终正寝的平静安详，从意外离世的措手不及，到与病魔抗争后的最终告别，每一个故事都充满了人间烟火的气息。影片以真诚而不煽情的方式，探讨了生命的意义和死亡的价值。朱一龙的表演依然细腻动人，将莫三妹这个看似粗糙实则温暖的殡葬师形象刻画得入木三分。",
    director: "刘江江",
    actors: ["朱一龙", "杨恩又", "王戈"],
    region: "中国大陆",
    language: "汉语普通话",
    duration: "125分钟",
    releaseDate: "2026-04-03",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%20with%20warm%20neighborhood%20funeral%20shop%20storefront%20at%20dusk%2C%20golden%20evening%20light%2C%20touching%20human%20story%20aesthetic%2C%20warm%20amber%20tones%2C%20sentimental%20atmosphere&width=600&height=900&seq=movie-poster-011&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Old%20Chinese%20neighborhood%20street%20at%20golden%20hour%20with%20small%20shops%20and%20warm%20sunlight%2C%20nostalgic%20atmosphere%2C%20everyday%20life%20scene%2C%20warm%20amber%20and%20soft%20shadow%20composition&width=1600&height=900&seq=movie-backdrop-011&orientation=landscape",
    isHot: false,
    isNew: false,
    tags: ["温情治愈", "现实主义", "口碑佳作"],
    viewCount: 1750000,
  },
  {
    id: "movie-012",
    title: "巨齿鲨3：深渊",
    titleEn: "The Meg 3: Abyss",
    year: 2026,
    category: "科幻片",
    categorySlug: "scifi",
    rating: 7.5,
    description: "乔纳斯带领的国际深海探险队在马里亚纳海沟深处，发现了一个比巨齿鲨更加恐怖的史前生物族群。",
    longDescription: "《巨齿鲨3：深渊》将深海冒险的惊险程度提升到了全新的高度。乔纳斯·泰勒带领的国际深海探险队在探索马里亚纳海沟最深处时，意外发现了一个与世隔绝的史前生态系统。在这里，不仅有着比巨齿鲨更加强大的掠食者，还有一个完整而危险的食物链。当探险队的深海设备遭到破坏，他们被困在了这个深海地狱之中。影片的特效场面全面升级，从巨齿鲨的震撼出场到深海巨兽的惊悚对决，每一场水下战斗都让人窒息。吴京和杰森·斯坦森的双雄组合再次展现了出色的动作戏份，而深海世界的视觉设计更是令人叹为观止。",
    director: "本·维特利",
    actors: ["杰森·斯坦森", "吴京", "蔡书雅", "克利夫·柯蒂斯"],
    region: "中美合拍",
    language: "英语 / 汉语普通话",
    duration: "115分钟",
    releaseDate: "2026-08-04",
    posterUrl: "https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%20with%20giant%20prehistoric%20shark%20rising%20from%20deep%20ocean%20toward%20diving%20cage%2C%20thrilling%20underwater%20scene%2C%20contrast%20of%20dark%20water%20and%20bioluminescence%2C%20blockbuster%20style&width=600&height=900&seq=movie-poster-012&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?width=1600&height=900&seq=movie-backdrop-012&orientation=landscape&query=Deep%20ocean%20abyss%20with%20giant%20shadow%20of%20massive%20creature%20moving%20through%20dark%20water%2C%00submarine%20lights%20cutting%20through%20darkness%2C%20thrilling%20cinematic%20underwater%20scene%2C%20deep%20teal%20and%20black%20contrast",
    isHot: false,
    isNew: true,
    tags: ["灾难大片", "中美合拍", "深海惊悚"],
    viewCount: 480000,
  },
];